<template>
  <div class="layout-content" v-on:scroll="scrollToBeginning" @wheel="scrollToBeginning" >
    <img class="fondElement" alt="rombus" src="../../assets/images/home/apokElement.png"/>
    <b-row>
      <b-col  xl="1" class="p-0 d-none d-lg-block d-md-block d-sm-block">
        <select-lang/>
      </b-col>
      <b-col cols="12" xl="11" class="position-relative" style="z-index: 1">
        <div class="d-sm-none text-center header-devices py-2">
          <select-lang/>
          <img
            alt="Apök"
            src="../../assets/images/home/logo.png"
            class="imgLogo w-50"
            :style="{ cursor: 'pointer' }"
            @click="$router.push({name: 'Home'})"
          />
        </div>
        <b-row class="content-page">
          <b-col
            class="menu py-4 pb-sm-2 pt-sm-5 px-4 d-none d-lg-block"
            :class="{'show-menu' : showMenu, 'hidden-menu' : hiddenMenu}"
            :style="{ backgroundColor: bg, display: mgMenu,  backgroundImage: `url(../${bgImg})`}" :key="bgImg"
            lg="3" xl="2">

            <content-bar :contentID='showAddress'>
              <template slot="header"> {{ textHeaderBar | translate }}</template>
              <template slot="footer">{{ textFooterBar | translate }}</template>
            </content-bar>

          </b-col>
          <b-col id="inside-block" class="text px-0" cols="12" lg="9"  xl="10">
            <div class="content-slider" @wheel="detectSection">
              <!-- <router-view v-on:imagenSide="navigate"></router-view> -->
              <section1 id="services" :service-type="serviceType" @modal-visibility-changed="doShow" :service-id="parseInt(serviceId, 10)"></section1>
              <section2 id="history"></section2>
              <section3 v-if="seeContact" @contactChange="contactEvent" id="info"></section3>
              <section4 v-else @back="contactEvent"></section4>
              <Footer class=""></Footer>
            </div>
          </b-col>
        </b-row>
        <sidebar v-on:navEvent="eventNavBar($event)"></sidebar>
      </b-col>
    </b-row>
    <img class="frontElement" alt="rombo apok" src="../../assets/images/home/apokElement.png" />
  </div>
</template>

<script>
  import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
  import Sidebar from '../Sidebar'
  import SelectLang from '../SelectLang'
  import menuBgAboutUs from '../../assets/images/aboutUs/apokNosotros.jpg'
  import menuBgPortfolio from '../../assets/images/portfolio/apokPortafolio.jpg'
  import menuBgContactUs from '../../assets/images/contact/apokContactanos.jpg'
  import ContentBar from '../contentBar/barContact.vue'
  import Section1 from '../../pages/Portfolio.vue'
  import Section2 from '../../pages/AboutUs.vue'
  import Section3 from '../../pages/Contact.vue'
  import Section4 from '../../pages/Gratitude.vue'
  import Footer from '../Footer.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'layout-content',
    components: { Footer, FontAwesomeIcon, FontAwesomeLayers, SelectLang, Sidebar, ContentBar, Section1, Section2, Section3, Section4 },
    props: {
      backgroundImage: {
        type: String,
        default: ''
      },
      hiddenBtn: {
        type: Boolean,
        default: false
      },
      idSlider: {
        type: Number,
        default: 0
      },
      serviceType: null,
      serviceId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        bg: '',
        bgImg: '',
        slider: this.idSlider,
        textHeaderBar: '',
        textFooterBar: '',
        showAddress: false,
        seeContact: true,
        scrollSize: 0,
        showing: false,
      }
    },
    mounted () {
      this.hiddenSection()
    },
    computed: {
      ...mapState(['mgMenu', 'showMenu', 'hiddenMenu'])
    },
    methods: {
      scrollToBeginning: function (event) {
        if (this.scrollSize === 0 && !this.showing) {
          if (event.type === 'wheel') {
            if (event.deltaY < 0) {
              this.$router.push({name: 'Home'})
            }
          }
        }
      },
      eventNavBar (e) {
        switch (e) {
          case 0:
            this.scrollSize = 0
            break
          case 1:
            this.scrollSize = document.getElementById('services').scrollHeight
            break
          case 2:
            this.scrollSize = document.getElementById('history').scrollHeight
            break
        }
        this.navigate(e)
      },
      contactEvent () {
        this.seeContact = !this.seeContact
      },
      showSection: function () {
        this.$store.commit('showSection')
      },
      hiddenSection: function () {
        if (this.$route.name === 'Services') {
          location.href = '#services'
          this.navigate(0)
        }
        if (this.$route.path === '/about-us') {
          location.href = '#history'
          this.scrollSize = document.getElementById('services').scrollHeight
          this.navigate(1)
        }
        if (this.$route.path === '/contact') {
          location.href = '#info'
          this.scrollSize = document.getElementById('history').scrollHeight
          this.navigate(2)
        }
      },
      navigate: function (e) {
        const event = e + 1
        if (event === 1) {
          this.bg = '#18668a'
          this.bgImg = menuBgPortfolio
          this.showAddress = false
          this.textHeaderBar = 'works.portfolio.textHeader'
          this.textFooterBar = 'works.portfolio.textFooter'
        }
        if (event === 2) {
          this.bg = '#f28800'
          this.bgImg = menuBgAboutUs
          this.showAddress = false
          this.textHeaderBar = 'aboutUs.us.textHeader'
          this.textFooterBar = 'aboutUs.us.textFooter'
        }
        if (event === 3 || this.$route.path === '/gratitude') {
          this.bg = '#f28800'
          this.bgImg = menuBgContactUs
          this.showAddress = true
          this.textHeaderBar = 'contact.content.textHeader'
          this.textFooterBar = 'contact.content.textFooter'
        }
      },
      detectSection (e) {
        this.scrollSize = this.scrollSize + e.deltaY
        let historySize = document.getElementById('history').scrollHeight
        let servicesSize = document.getElementById('services').scrollHeight
        // var infoSize = document.getElementById('info').scrollHeight
        // console.log(this.scrollSize)
        if (this.scrollSize < 0) {
          this.scrollSize = 0
        } else {
          if (this.scrollSize > (historySize + servicesSize) - 410) {
            this.scrollSize = (historySize + servicesSize) - 450
          } else {
            if (this.scrollSize >= servicesSize - 400) {
              if (this.scrollSize >= historySize) {
                this.navigate(2)
              } else {
                this.navigate(1)
              }
            } else {
              this.navigate(0)
            }
          }
        }
      },
      doShow (e) {
        this.showing = e
      }
    },
    created () {
      window.addEventListener('scroll', this.scrollToBeginning)
    },
    destroyed () {
      window.removeEventListener('scroll', this.scrollToBeginning)
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../../assets/styles/layout-contents.scss';


</style>



// WEBPACK FOOTER //
// src/components/layouts/LayoutContent.vue